import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from 'app/app.component';
import { fuseConfig } from 'app/fuse-config';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { API_BASE_URL } from '../shared/service-proxies/service-proxies';
import { ServiceProxyModule } from '../shared/service-proxies/service-proxy.module';
import { environment } from './../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { AuthGuardService } from './shared/guard/authorization-guard.service';
import { HRMSInterceptor } from './shared/interceptor/app-interceptor';
import { CoreModule } from './shared/modules/core.module';
import { PrimengModule } from './shared/modules/primeng.module';
import { SharedModule } from './shared/modules/shared.module';
import { DocumentService } from './shared/service/document.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DatePipe } from '@angular/common';
import { ProfileimageComponent } from './main/profileimage/profileimage.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DocumentVaultMasterComponent } from './main/document-vault-master/document-vault-master.component';
// import { QrAttendanceModule } from './main/qr-attendance/qr-attendance.module';
@NgModule({
    declarations: [
        AppComponent,
        // DocumentVaultMasterComponent,
    ],
    imports: [
        CoreModule,
        AppRoutingModule,
        TranslateModule.forRoot(),
        // Material moment date module
        MatMomentDateModule,
        // Material
        MatButtonModule,
        MatIconModule,
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        PrimengModule,
        SampleModule,
        SharedModule,
        // App modules
        LayoutModule,
        ToastModule,
        ServiceProxyModule,
        HttpClientModule,
        AuthenticationModule,
        NgxMaterialTimepickerModule,
        NgHttpLoaderModule.forRoot(),
        // QrAttendanceModule,
    ],
    providers: [
        ConfirmationService, MessageService, AuthGuardService, DocumentService, DatePipe,
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
        { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
        { provide: HTTP_INTERCEPTORS, useClass: HRMSInterceptor, multi: true },
        JwtHelperService],
    bootstrap: [
        AppComponent
    ],
    schemas: [
        // CUSTOM_ELEMENTS_SCHEMA
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule {
}

export function getRemoteServiceBaseUrl(): string {
    return environment.baseURL;
}